import { render } from "./app-form-type-business.vue?vue&type=template&id=658cb3e6"
import script from "./app-form-type-business.vue?vue&type=script&lang=js"
export * from "./app-form-type-business.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/reference/app-form-type-business.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "658cb3e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('658cb3e6', __exports__)) {
    console.log('reload')
    api.reload('658cb3e6', __exports__)
  }
  
  module.hot.accept("./app-form-type-business.vue?vue&type=template&id=658cb3e6", () => {
    console.log('re-render')
    api.rerender('658cb3e6', render)
  })

}


export default __exports__